<template>
    <div id="about">
        <div class="landing-bg one"></div>
        <div class="landing-bg two"></div>
        <vue-particles
            :move-speed="0.5"
            :particle-opacity="0.3"
            :hover-effect="false"
            :click-effect="false"
            color="#dedede"
        ></vue-particles>
        <div class="aboutContainer">
            <h1 class="title is-1">About</h1>
            <hr />

            <p class="subtitle aboutText is-size-5 is-size-7-mobile">
                Spydify is a Spotify visualiser designed to provide users with
                an interactive space to explore their music tastes, visualise
                any music trends and discover tracks or artists that they might
                otherwise never have found.
            </p>
            <p class="subtitle aboutText is-size-5 is-size-7-mobile">
                Spydify works by providing the user with a graph where the nodes
                are represented as artists or songs. This graph will show the
                user's preferred artists and songs and, from there, branch out
                to show music that is similar the those that the user currently
                listens to. The user will also be able to generate their own
                graph by selecting data of their choice.
            </p>
            <p class="subtitle aboutText is-size-5 is-size-7-mobile">
                Alongside these graphs, we will also provide the user with
                infographics, giving them access to fun information that they
                would otherwise never know, such as how “danceable” the music
                they listen to is, and lists of their top artists and tracks.
            </p>

            <hr />
            <button
                class="button is-primary is-rounded"
                :class="{ 'is-loading': loading }"
                @click="login()"
            >
                Back To Landing Page
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "About",
    data() {
        return {
            loading: false
        };
    },
    methods: {
        login() {
            this.loading = true;
            this.$router.push("/");
        }
    }
};
</script>

<style lang="scss">
#landing {
    height: 100vh;
}

.aboutText {
    text-align: center;
}

.aboutContainer {
    position: absolute;
    top: 50%;
    left: 40%;
    transform: translate(-35%, -50%);
    text-align: center;

    & .button {
        font-weight: bold;
    }

    & .subtitle {
        margin-bottom: 0.5rem !important;
    }
}

#particles-js {
    width: 100%;
    height: 100%;
    position: absolute;
}

.landing-bg {
    width: 100%;
    height: 100%;
    position: absolute;

    &.one {
        background-image: linear-gradient(90deg, #c074b2, #8ab5e8);
    }

    &.two {
        background-image: linear-gradient(transparent, #000);
    }
}
</style>
